const DesktopTableHeader = ({ columns, hasActions }) => {
  return (
    <thead>
      <tr
        className="
          border-b
          border-stroke

          bg-whiten

          dark:border-strokedark
          dark:bg-meta-4
        "
      >
        {columns.map((col) => (
          <th
            key={col.accessor || col.label}
            className="
              px-5
              py-4

              text-left
              text-sm
              font-semibold

              text-black
              dark:text-white
            "
          >
            {col.label}
          </th>
        ))}

        {hasActions && (
          <th
            className="
              px-5
              py-4

              text-center
              text-sm
              font-semibold

              text-black
              dark:text-white
            "
          >
            Acciones
          </th>
        )}
      </tr>
    </thead>
  );
};

export default DesktopTableHeader;
